import { makeLogger } from "@/shared/consola";

const makeEventsEndpoint = (playerUUID) =>
    `${process.env.VUE_APP_ORIGIN}/api/players/${playerUUID}/issued-certificates/events`;

const logger = makeLogger("issued-certificate.events");

const EVENTS = {
    GRANTED: "certificate-granted",
    ALREADY_GRANTED: "certificate-already-granted",
};

export const issuedCertificateEvents = {
    EVENTS,
    subscribeToEvent(playerUUID, subscriber = () => {}) {
        const evtSource = new EventSource(makeEventsEndpoint(playerUUID), {
            withCredentials: true,
        });
        const mapJSON = (e) => {
            logger.trace("Original event", e);
            subscriber({
                type: e.type,
                payload: JSON.parse(e.data),
            });
        };
        evtSource.addEventListener(EVENTS.GRANTED, mapJSON);
        evtSource.addEventListener(EVENTS.ALREADY_GRANTED, mapJSON);
        return evtSource;
    },
};
